import { useNavigate } from '@remix-run/react'
import { type MouseEvent, type ReactNode } from 'react'

export function HashLink({
	href,
	className,
	children,
}: {
	href: `#${string}`
	className?: string
	children: ReactNode
}) {
	const navigate = useNavigate()

	function onClick(event: MouseEvent<HTMLAnchorElement>) {
		const el = document.getElementById(href.slice(1))
		if (!el) return
		event.preventDefault()
		const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
		el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' })
		void navigate(href, { preventScrollReset: true })
	}

	return (
		<a href={href} className={className} onClick={onClick}>
			{children}
		</a>
	)
}
